import { default as React, useEffect, useState } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import List from "../list";
import { ScheduledExchangesDto, GetID1ScheduledExchangesResponse, GetID1ScheduledExchangesQuery } from "core/backend/data";
import SheetDataPart from "components/sheetDataPart";
import SheetHeader from "components/sheetHeader";
import { ApplicationState } from "core/app";
import { keys } from "ts-transformer-keys";
import { PageList } from "core/pages/pageList";
import { makeRequest } from "utils";

interface OwnState {
    applicationState: ApplicationState;
}
export const senderId = "scheduledExchanges";
export const page_config: PageList =
{
    apiUrl: "ID1_scheduledExchanges",
    webUrl: "ID1_scheduledExchanges",
    menu: "ibwt_common:menuScheduledExchanges",
    title: "ibwt_common:titleScheduledExchanges",
    apiType: "data",
    response: JSON.stringify(keys<GetID1ScheduledExchangesResponse>()),
    dto: JSON.stringify(keys<ScheduledExchangesDto>()),
    parameters: JSON.stringify(keys<GetID1ScheduledExchangesQuery>()),
    dateSteps: "D",
    getDefaultToDateTime: (applicationState: ApplicationState) => applicationState.getUntilFor1Day()
};

type PageProps = OwnState & WithTranslation;

const Page = ({ t, applicationState }: PageProps) => {

    const initialData: GetID1ScheduledExchangesResponse = { data: [], messages: [], rejected: false };
    const [data, setData] = useState(initialData);
    const [isLoading, setLoading] = useState(false);
    const [error, setError] = useState("");

    useEffect(() => {
        (async function runAsync() {
            applicationState.handleInputAvailablilityChange(page_config.dateSteps, true, false, keys<ScheduledExchangesDto>());
            makeRequest<GetID1ScheduledExchangesResponse>(0, applicationState.pageSize, applicationState, initialData, null, senderId, page_config, setLoading, setError, setData);
        })();
    }, [applicationState.selectedDate]);

    return (
        <>
            <SheetHeader showDownload={true} applicationState={applicationState} title={t(page_config.title)} pageConfig={page_config} />
            <SheetDataPart isLoading={isLoading} data={data.data} error={error}>
                <List data={data.data} borders={applicationState.selectedBorders.filter((f) => f.selected)} />
            </SheetDataPart>
        </>
    );
};

export default withTranslation()(Page);
